import React, { useState, useRef, useEffect } from "react";
import { FaCoins, FaUser, FaCalendarAlt, FaSignOutAlt } from "react-icons/fa";
import "./UserDropdown.css";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser, selectUser } from "../../../../Store/userSlice";

const UserDropdown = () => {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector(selectUser);

  const initials = `${user.firstname?.[0] || ""}${user.lastname?.[0] || ""}`.toUpperCase();

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const logout = () => {
    dispatch(logoutUser());
    window.location.assign("/login");
  };

  const go = (path) => {
    setOpen(false);
    navigate(path);
  };

  return (
    <div className="extra-nav">
      <div className="navbar-jetons">
        <FaCoins className="jetons-coin-icon" style={{ color: "#f59e0b" }} />
        <span>{user.jetons}</span>
      </div>
      <div className="user-dropdown-wrapper" ref={wrapperRef}>
        <button
          className="user-initials-btn"
          onClick={() => setOpen((prev) => !prev)}
          aria-label="Menu utilisateur"
        >
          {initials}
        </button>
        {open && (
          <div className="user-menu">
            <div className="user-menu-header">
              <span className="user-menu-name">
                {user.firstname} {user.lastname}
              </span>
              <span className="user-menu-email">{user.email}</span>
            </div>
            <div className="user-menu-divider" />
            <button className="user-menu-item" onClick={() => go("/profile")}>
              <FaUser className="user-menu-icon" />
              Mon profil
            </button>
            <button
              className="user-menu-item"
              onClick={() => go("/my-reservation")}
            >
              <FaCalendarAlt className="user-menu-icon" />
              Mes réservations
            </button>
            <div className="user-menu-divider" />
            <button className="user-menu-item user-menu-logout" onClick={logout}>
              <FaSignOutAlt className="user-menu-icon" />
              Se déconnecter
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default UserDropdown;
